var _number = {
  //乘法
  multiply (arg1, arg2) {
    var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
    try { m += s1.split(".")[1].length } catch (e) { }
    try { m += s2.split(".")[1].length } catch (e) { }
    return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)
  },

  //除法   
  divide (num1, num2) {
    let t1, t2, r1, r2;
    try {
      t1 = num1.toString().split('.')[1].length
    } catch (e) {
      t1 = 0
    }
    try {
      t2 = num2.toString().split('.')[1].length
    } catch (e) {
      t2 = 0
    }
    r1 = Number(num1.toString().replace('.', ''))
    r2 = Number(num2.toString().replace('.', ''))
    return (r1 / r2) * Math.pow(10, t2 - t1)
  },
  //减法
  sub (num1, num2) {
    let r1, r2, m, n;
    try {
      r1 = num1.toString().split('.')[1].length
    } catch (e) {
      r1 = 0
    }
    try {
      r2 = num2.toString().split('.')[1].length
    } catch (e) {
      r2 = 0
    }
    n = Math.max(r1, r2)
    m = Math.pow(10, n)
    return Number(((num1 * m - num2 * m) / m).toFixed(n))
  },
  //加法
  add (num1, num2) {
    let r1, r2, m;
    try {
      r1 = num1.toString().split('.')[1].length
    } catch (e) {
      r1 = 0
    }
    try {
      r2 = num2.toString().split('.')[1].length
    } catch (e) {
      r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2))
    return (num1 * m + num2 * m) / m
  }





}

export default _number
